module.exports = __webpack_public_path__ + "img/piece-icon.ad674174.png";